module.exports = __webpack_public_path__ + "static/media/SFX_SwishIn_1_soft_reversed.dac7ad6a.mp3";